import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { requireBackoffice } from '../auth/guard.ts'
import { numericIdParam } from './params.ts'
import { rootRoute } from './root.tsx'

// The fixture and what the cameras got of it. Loaded with useQuery and not a loader,
// `kitDetailRoute`'s reason: the 404 stays an in-page message.

export const matchDetailRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/matches/$id',
  params: numericIdParam,
  beforeLoad: requireBackoffice,
  component: lazyRouteComponent(() => import('../pages/match-detail.tsx')),
})

/** The fixture as a link target, with the id its path requires. */
export function matchCardLink(matchId: number) {
  return { to: matchDetailRoute.to, params: { id: matchId } } as const
}
